﻿window.itemTemplateGrilleClickVue = function (contentElement, dataTemplate, type, dxGrid, option) {
    option.bddCtrl.mAddFunctionOnModifiedItemData(["structures", "structures_contact", "contact"], contentElement,
        function (action, itemData) {
            if (action == "supp" && typeof itemData != 'undefined' && typeof dataTemplate.strcon != "undefined") {
                var obj = option.bddCtrl.getObjet(itemData)
                if ((obj.mGetTable().nom == "structures" || obj.mGetTable().nom == "structures_contact" || obj.mGetTable().nom == "contact") &&
                    obj.cle() == dataTemplate.strcon.id_key && obj.mGetTable().id_table == dataTemplate.strcon.id_table_key) {
                    //on a supprimé le destinataire
                    dxGrid.mUpdateData("modif", dataTemplate.id_table_key, dataTemplate.id_key)
                }
            }
        })

    if (dataTemplate.track.is_robot == "1") contentElement.css({
        "text-decoration": "line-through",
        "opacity": "0.2"
    })
    var $Table = $("<table style='width:100%;height:100%;table-layout:fixed;text-align:left;'/>").appendTo(contentElement)
    var $Tr = $("<tr/>").appendTo($Table)


    var $TdUtiTrack = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
    if (typeof dataTemplate.com != 'undefined') {
        $("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdUtiTrack).dxCtrlImgSimpleStrConUti({
            bddCtrl: option.bddCtrl,
            idTable: option.bddCtrl.getObjet("utilisateur").mGetTable().id_table,
            id: dataTemplate.com.id_utilisateur,
            text: option.bddCtrl.getObjet("utilisateur", dataTemplate.com.id_utilisateur).mGetLib1()
        })
    }

    var nbTd = 0
    if (dataTemplate.envoilien) nbTd += 1
    if (option.showCom) nbTd += 1
    if (option.showStrcon) nbTd += 1
    var widthPercent = 100 / nbTd

    if (dataTemplate.envoilien) {
        var txt = ""
        if (dataTemplate.envoilien.libelle && dataTemplate.envoilien.libelle.length > 0) txt = dataTemplate.envoilien.libelle
        var $TdLien = $("<td style='width:" + widthPercent + "%;max-width:150px;padding:0 5px;font-family:barlow condensed;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' class='state-hover2'></td>").appendTo($Tr)
        $TdLien.attr("title", ((txt.length > 0) ? "(" + txt + ")<br/>" : "") + "<u>" + dataTemplate.envoilien.lien + "</u>")
        var $span = $("<span></span>").appendTo($TdLien)
        if (txt.length > 0) $span.text("(" + txt + ") ")
        var $A = $("<a href='javascript:void(0)' style='pointer-events:none;'>" + dataTemplate.envoilien.lien.reduit(20) + "</a>").appendTo($span)
        if (dataTemplate.envoilien.lien == "https://lien_ouvrir_email_dans_navigateur") {
            $A.text("Lien visu navigateur")
        } else {
            $TdLien.on("click", function (e) { e.stopPropagation(); window.open(dataTemplate.envoilien.lien, "_blank") })
        }
    }

    if (option.showCom && typeof dataTemplate.com != 'undefined') {
        var $TdCom = $("<td style='padding:0 5px;width:" + widthPercent + "%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-style:italic;' class='state-hover2'/>").appendTo($Tr)
        $TdCom.text(dataTemplate.com.objet)
        $TdCom.attr("title", "Afficher l'email<br/>" + dataTemplate.com.objet)
        $TdCom.on("click", function (e) {
            e.stopPropagation();
            option.bddCtrl.getObjet("com_email_envoi", dataTemplate.com.id_key).mShowPopup()
        })
    }

    if (option.showStrcon) {
        var $TdStrCon = $("<td style='padding:0 5px;width:" + widthPercent + "%;'/>").appendTo($Tr)
        var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($TdStrCon)
        var $Tr = $("<tr/>").appendTo($Table)
        if (typeof dataTemplate.strcon == "undefined") {
            $Table.css("opacity", "0.3")
            var $TdICone = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
            var $TdImage = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
            var $TdLib = $("<td style='width:50%;padding:0 3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:bold;'/>").appendTo($Tr)
            $TdLib.text("Aucune fiche pour l'adresse email")
        } else {
            var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table_key)
            var obj = option.bddCtrl.getObjet(table.nom)
            $TdStrCon.addClass('state-hover2')
            var $TdICone = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
            obj.mGetIcone(dataTemplate.strcon).appendTo($TdICone)
            var $TdImage = $("<td style='width:20px;padding:0 3px;'/>").appendTo($Tr)
            $("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdImage).dxCtrlImgSimpleStrConUti({
                bddCtrl: option.bddCtrl,
                idTable: table.id_table,
                id: dataTemplate.strcon.id_key,
                dataTemplate:dataTemplate,
                text: ""
            })
            var $TdLib = $("<td style='width:50%;padding:0 3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:bold;'/>").appendTo($Tr)
            $TdLib.text(obj.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate.strcon))
            $TdStrCon.attr("title", "Ouvrir la fiche<br/>" + obj.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate.strcon))
            $TdStrCon.on("click", function (e) { e.stopPropagation(); option.bddCtrl.getObjet(table.nom, dataTemplate.strcon.id_key).mShowPopup() })
        }

        var $TdEmail = $("<td style='width:50%;padding:0 3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'/>").appendTo($Tr)
        if (typeof dataTemplate.track.id_com_email_envoi_tracking_click != 'undefined' || typeof dataTemplate.track.id_com_email_envoi_tracking_vue != 'undefined') {
            if (dataTemplate.track.is_robot == 1) {
                $("<i class='fas fa-robot dx-theme-accent-as-text-color'></i>").appendTo($TdEmail)
            }
            $("<u/>").appendTo($TdEmail).text(dataTemplate.com_destinataire.adresse_email)

        } else if (typeof dataTemplate.track.id_com_sms_envoi_tracking_click != 'undefined' || typeof dataTemplate.track.id_com_sms_envoi_tracking_vue != 'undefined') {
            var tel = new cTelephone(dataTemplate.com_destinataire.tel_code_pays, dataTemplate.com_destinataire.tel_sms)
            var txt = ""
            if (!tel.hasValue()) { txt = "(aucun téléphone)" }
            else { txt = tel.mGetValueMiseEnForme() }
            $("<span/>").appendTo($TdEmail).text(txt)
        }
    }

}